
import ccc from '../assets/png/ccc.png'
export const achievementData = {
    bio : "",
    achievements : [
        {
            id : 1,
            title : 'Full Stack Web Development',
            details : 'HTML, CSS, Boostrap, Node.js, Express.js, MongoDB',
            date : 'Jan 28, 2021',
            field : 'Development',
            image : 'https://udemy-certificate.s3.amazonaws.com/image/UC-bc4283b6-b916-4995-b3e2-6753807f62d5.jpg'
        },
        {
            id : 2,
            title : 'React Development',
            details : 'React.js, Next.js',
            date : 'May 25, 2021',
            field : 'Development',
            image : 'https://udemy-certificate.s3.amazonaws.com/image/UC-a76bf3a9-cd2b-4fc1-81b4-d08478ba2ca4.jpg'
        },
        {
            id : 3,
            title : 'Data Structures and Algorithms',
            details : 'DSA in C++',
            date : 'Apr 13, 2021',
            field : 'Coding',
            image : ccc
        }

    ]
}


// Do not remove any fields.
// Leave it blank instead as shown below.

/*

export const achievementData = {
    bio : "",
    achievements : []
}

*/